import { useSelector } from "react-redux"
import { Navigate } from "react-router-dom"
import { useAccountAlias } from "resources/account"

export default function withFeatureGate(WrappedComponent, featureFlagKey) {
  const ComponentWithFeatureGate = (props) => {
    const account = useAccountAlias()
    const accountFeatureFlags = useSelector(state => state.global.data.enabledFeatures?.data, false)

    if (!featureFlagKey || !accountFeatureFlags || !!accountFeatureFlags[featureFlagKey]) {
      return <WrappedComponent {...props} />
    }

    return <Navigate to={`/${account}/home`} replace />
  }

  ComponentWithFeatureGate.displayName = `WithFeatureGate(${WrappedComponent.displayName || WrappedComponent.name})`

  return ComponentWithFeatureGate
}
